import { createSlice } from "@reduxjs/toolkit"
import { COUNTRY_CODE } from "@utils/constants"
import { pickupLocationApiSlice } from "./pickupLocationApiSlice"

export const initialState = {
  all: {
    data: [],
    page: 1,
    size: 10,
    totalData: 0,
    sort: {},
  },
  loading: false,
  one: {
    title: "",
    location: "",
    is_active: true,
    mobile_prefix: COUNTRY_CODE,
    mobile: "",
  },
  query: { page: "1", size: "10" },
  errors: {},
  chosen_location: [],
}

export const pickupLocationSlice = createSlice({
  name: "pickupLocation",
  initialState,
  reducers: {
    setOneValue: (state, action) => {
      if (action.payload.key) {
        state.one[action.payload.key] = action.payload.value
        state.errors[action.payload.errors] = " "
      } else {
        state.one = action.payload
      }
    },
    clearErrors: (state, action) => {
      state.errors = initialState.errors
    },
    clearQuery: (state, action) => {
      state.query = initialState.query
    },
    clearOne: (state, action) => {
      state.one = initialState.errors
    },
    setQueryValue: (state, action) => {
      if (action.payload.key) {
        state.query[action.payload.key] = action.payload.value
      } else {
        state.query = action.payload
      }
    },
    addChosenLocation: (state, action) => {
      const LocationIndex = state.chosen_location.indexOf(action.payload)
      if (LocationIndex >= 0) {
        const tempChosenLocation = [...state.chosen_location]
        tempChosenLocation.splice(LocationIndex, 1)
        state.chosen_location = tempChosenLocation
      } else {
        state.chosen_location = [...state.chosen_location, action.payload]
      }
    },
    clearChosenLocation: (state, action) => {
      state.chosen_location = initialState.chosen_location
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        pickupLocationApiSlice.endpoints.loadOnePickupLocation.matchFulfilled,
        (state, { payload }) => {
          state.one = payload.data
        },
      )
      .addMatcher(
        pickupLocationApiSlice.endpoints.loadAllPickupLocation.matchFulfilled,
        (state, { payload }) => {
          state.all = payload
        },
      )
  },
})

export const {
  setOneValue,
  clearErrors,
  clearQuery,
  clearOne,
  setQueryValue,
  clearChosenLocation,
  addChosenLocation,
} = pickupLocationSlice.actions

export default pickupLocationSlice.reducer
